import { render, staticRenderFns } from "./MainLedgerPayPrint.vue?vue&type=template&id=2ad95fdf&scoped=true"
import script from "./MainLedgerPayPrint.vue?vue&type=script&lang=js"
export * from "./MainLedgerPayPrint.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPayPrint.vue?vue&type=style&index=0&id=2ad95fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad95fdf",
  null
  
)

export default component.exports